@if (workCenter$ | async; as workCenter) {
  <div class="layout-col full">
    <!-- Header Section -->
    <div class="layout-row">
      @if (embedded) {
        <div class="flex layout-row place-start-center gap-md p-lg">
          <ng-container
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: workCenter }"
          ></ng-container>
        </div>
      } @else {
        <mat-toolbar elderTheme class="gap-md">
          <button mat-icon-button (click)="onClose($event)">
            <mat-icon>close</mat-icon>
          </button>
          <ng-container
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: workCenter }"
          ></ng-container>
        </mat-toolbar>
      }
    </div>
    <!-- Content -->
    <div class="flex layout-col">
      <mat-tab-group class="flex" animationDuration="0ms" elderTabGroupRouting="wcDetailTab">
        <!-- Tab Overview -->
        <mat-tab label="{{ 'context.overview' | translate }}">
          <elder-single-pane-wrapper>
            <elder-pane-header>
              <elder-pane-title>{{ 'context.general' | translate }}</elder-pane-title>
              <elder-pane-actions>
                <button mat-icon-button [disabled]="!mainFrm.form.valid" (click)="onSave($event)">
                  <mat-icon>save</mat-icon>
                </button>
                <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="creationMode">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  @let active = workCenter.archivedAt == null;
                  <button mat-menu-item (click)="requestArchival(workCenter, false)">
                    <mat-icon>inventory_2</mat-icon>
                    @if (active) {
                      <span>{{ 'actions.archive' | translate }}</span>
                    } @else {
                      <span>{{ 'actions.unarchive' | translate }}</span>
                    }
                  </button>
                  <button mat-menu-item [disabled]="active" (click)="requestArchival(workCenter, true)">
                    <mat-icon>delete</mat-icon>
                    <span>{{ 'actions.delete' | translate }}</span>
                  </button>
                </mat-menu>
              </elder-pane-actions>
            </elder-pane-header>
            <elder-pane-content>
              <form #mainFrm="ngForm" class="flex layout-row gap-xl">
                <!-- Identification -->
                <div class="flex layout-col">
                  <h4 elderpaneSubtitle>{{ 'context.identification' | translate }}</h4>
                  <div class="layout-row place-start-center gap-sm">
                    <mat-form-field>
                      <mat-label>{{ 'facilities.facility' | translate }}</mat-label>
                      <elder-select
                        appFacilitySelect
                        name="facility"
                        required
                        valueAsId
                        [(ngModel)]="workCenter.facility"
                        [disabled]="!creationMode"
                        placeholder="{{ 'facilities.facility' | translate }}"
                      >
                      </elder-select>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>{{ 'context.number' | translate }}</mat-label>
                      <input
                        matInput
                        name="number"
                        required
                        placeholder="{{ 'context.number' | translate }}"
                        [(ngModel)]="workCenter.number"
                        #numberModel="ngModel"
                      />
                      @if (numberModel.errors?.['required']) {
                        <mat-error>{{ 'validations.required' | translate }}</mat-error>
                      }
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>{{ 'context.name' | translate }}</mat-label>
                      <input
                        matInput
                        name="name"
                        placeholder="{{ 'context.name' | translate }}"
                        [(ngModel)]="workCenter.name"
                      />
                    </mat-form-field>
                  </div>
                  <div class="layout-row place-start-center gap-sm">
                    <mat-form-field>
                      <mat-label>{{ 'context.type' | translate }}</mat-label>
                      <elder-select
                        appWorkCenterTypeSelect
                        name="type"
                        required
                        valueAsId
                        [(ngModel)]="workCenter.type"
                      >
                      </elder-select>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>{{
                        'shopfloor.workcenters.assignmentStrategies.assignmentStrategy' | translate
                      }}</mat-label>
                      <elder-select
                        appAssignmentStrategySelect
                        name="strategy"
                        required
                        valueAsId
                        [(ngModel)]="workCenter.assignmentStrategy"
                      >
                      </elder-select>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>{{ 'context.description' | translate }}</mat-label>
                      <input
                        matInput
                        name="description"
                        placeholder="{{ 'context.description' | translate }}"
                        [(ngModel)]="workCenter.description"
                      />
                    </mat-form-field>
                  </div>
                  <h4 elderpaneSubtitle>
                    {{ 'shopfloor.workcenters.processing.title' | translate }}
                  </h4>
                  <div class="layout-row place-start-center gap-sm">
                    <mat-form-field>
                      <mat-label>{{
                        'shopfloor.workcenters.processing.qtyMultipleOf' | translate
                      }}</mat-label>
                      <input
                        matInput
                        name="multipleOf"
                        type="number"
                        required
                        min="1"
                        pattern="[0-9]*"
                        placeholder="{{
                          'shopfloor.workcenters.processing.qtyMultipleOf' | translate
                        }}"
                        [(ngModel)]="workCenter.processing.quantityMultipleOf"
                      />
                    </mat-form-field>
                  </div>
                  <h4 elderpaneSubtitle>{{ 'shopfloor.workstations.title' | translate }}</h4>
                  <app-work-station-table
                    class="flex"
                    [(workStationIds)]="workCenter.workStations"
                    [facilityId]="workCenter.facility"
                  >
                  </app-work-station-table>
                </div>
              </form>
            </elder-pane-content>
          </elder-single-pane-wrapper>
        </mat-tab>
        <!-- Tab Packaging -->
        <mat-tab label="{{ 'packaging.process' | translate }}">
          <elder-single-pane-wrapper>
            <elder-pane-header>
              <elder-pane-title>{{ 'packaging.process' | translate }}</elder-pane-title>
              <elder-pane-actions>
                <button
                  mat-icon-button
                  [disabled]="!packagingFrm.form.valid"
                  (click)="onSave($event)"
                >
                  <mat-icon>save</mat-icon>
                </button>
              </elder-pane-actions>
            </elder-pane-header>
            <elder-pane-content>
              <form #packagingFrm="ngForm" class="flex layout-row gap-xxl">
                <app-work-center-packaging [workCenter]="workCenter"></app-work-center-packaging>
              </form>
            </elder-pane-content>
          </elder-single-pane-wrapper>
        </mat-tab>
        <!-- Tab Labeling -->
        <mat-tab label="{{ 'labeling.title' | translate }}">
          <elder-single-pane-wrapper>
            <elder-pane-header>
              <elder-pane-title>{{ 'labeling.title' | translate }}</elder-pane-title>
              <elder-pane-actions>
                <button
                  mat-icon-button
                  [disabled]="!packagingFrm.form.valid"
                  (click)="onSave($event)"
                >
                  <mat-icon>save</mat-icon>
                </button>
              </elder-pane-actions>
            </elder-pane-header>
            <elder-pane-content>
              <form #packagingFrm="ngForm" class="flex layout-row gap-xxl">
                <app-work-center-labeling [workCenter]="workCenter"></app-work-center-labeling>
              </form>
            </elder-pane-content>
          </elder-single-pane-wrapper>
        </mat-tab>
        <!-- Tab Properties -->
        <mat-tab label="{{ 'properties.title' | translate }}">
          <elder-single-pane-wrapper>
            <elder-pane-header>
              <elder-pane-title>{{ 'properties.title' | translate }}</elder-pane-title>
              <elder-pane-actions>
                <button mat-icon-button (click)="onSave($event)">
                  <mat-icon>save</mat-icon>
                </button>
              </elder-pane-actions>
            </elder-pane-header>
            <elder-pane-content class="flex" padding="0">
              <app-property-conf-table
                [name]="'properties'"
                class="flex"
                [properties]="properties$ | async"
              >
              </app-property-conf-table>
            </elder-pane-content>
          </elder-single-pane-wrapper>
        </mat-tab>
        <!-- Tab Position Properties -->
        <mat-tab label="{{ 'positions.properties' | translate }}">
          <!-- TODO: move save into toolbar, move inner panes up -->
          <elder-single-pane-wrapper>
            <elder-pane-header>
              <elder-pane-title>{{ 'positions.properties' | translate }}</elder-pane-title>
              <elder-pane-actions>
                <button mat-icon-button (click)="onSave($event)">
                  <mat-icon>save</mat-icon>
                </button>
              </elder-pane-actions>
            </elder-pane-header>
            <elder-pane-content class="flex">
              <app-dynamic-property-conf-browser
                class="flex"
                [availableSpecs]="(workCenterType$ | async)?.dynamicPropertySpecs"
                [dynamicPropertyConfs]="dynamicProperties$ | async"
                (dynamicPropertyConfsChange)="dynamicProperties$.next($event)"
              >
              </app-dynamic-property-conf-browser>
            </elder-pane-content>
          </elder-single-pane-wrapper>
        </mat-tab>
        <!-- Tab Capabilities -->
        <mat-tab label="{{ 'capabilities.capabilities' | translate }}" [disabled]="creationMode">
          <app-work-center-detail-capabilities
            class="flex"
            [workCenter]="workCenter"
            (save)="onSave($event)"
          >
          </app-work-center-detail-capabilities>
        </mat-tab>
        <!-- Tab Work Schedule -->
        <mat-tab label="{{ 'schedules.workSchedule' | translate }}" [disabled]="creationMode">
          <app-work-center-schedule-detail
            *matTabContent
            class="flex"
            [workCenterId]="workCenter?.id"
            [facilityId]="workCenter?.facility"
          >
          </app-work-center-schedule-detail>
        </mat-tab>
        <!-- Tab Sequential Numbering -->
        <mat-tab
          label="{{ 'numberSequences.numberSequence' | translate }}"
          [disabled]="creationMode"
        >
          <app-number-sequence-detail
            [embedded]="true"
            [canCreate]="true"
            [canSave]="true"
            [canDelete]="true"
            [sequence]="numberSequence$ | async"
            (createRequest)="onNumberSequenceCreation()"
            (saveRequest)="onNumberSequenceSave($event)"
            (deleteRequest)="onNumberSequenceDeletion($event)"
          >
          </app-number-sequence-detail>
        </mat-tab>
        <!-- Tab Item sort -->
        <mat-tab label="{{ 'context.itemsSort' | translate }}">
          <elder-single-pane-wrapper class="flex">
            <elder-pane-header>
              <elder-pane-actions>
                <button mat-icon-button (click)="onSave($event)">
                  <mat-icon>save</mat-icon>
                </button>
              </elder-pane-actions>
            </elder-pane-header>
            <elder-pane-content class="flex" padding="0">
              <app-item-sort-spec-detail class="flex" [(itemSortSpec)]="workCenter.itemSortSpec">
              </app-item-sort-spec-detail>
            </elder-pane-content>
          </elder-single-pane-wrapper>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
}

<ng-template #header let-workCenter>
  @if (creationMode) {
    <span>
      {{ 'shopfloor.workcenters.new' | translate }}
    </span>
  } @else {
    <mat-icon>{{ workCenter.archivedAt ? 'inventory_2' : ' work ' }}</mat-icon>
    <elder-header [header]="workCenter.name" [subheader]="'ID: ' + workCenter.id"> </elder-header>
  }
</ng-template>
